/**
 * 運送PL の読み込み(2026-10-23)。読むだけで書き込みはしない。
 *  - Routine の行: routine_pl を列の月で読む(月は最大4つなので in で1回)
 *  - Gate の取引: 勘定科目別の予実と同じ読み方(事業部=運送・PL の状態・計上月)。実績・見込みは plEntryOf() で分ける
 */
import { collection, getDocs, query, where } from 'firebase/firestore';
import { getDb } from '@core/lib/firebase';
import { fetchPlTransactionsForMonths } from '@core/pl/accountPlRepo';
import type { MonthStr, RoutinePlLine, Transaction } from '@core/lib/types';
import { UNSO_DEPARTMENT_ID } from './unsoPl';

export async function fetchRoutinePlLines(months: MonthStr[]): Promise<RoutinePlLine[]> {
  if (months.length === 0) return [];
  const snap = await getDocs(query(collection(getDb(), 'routine_pl'), where('month', 'in', months.slice(0, 10))));
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<RoutinePlLine, 'id'>) }));
}

export async function fetchUnsoTransactions(months: MonthStr[]): Promise<Transaction[]> {
  return fetchPlTransactionsForMonths(UNSO_DEPARTMENT_ID, months);
}
